import { render } from "./Campaign.vue?vue&type=template&id=47c541e0&scoped=true"
import script from "./Campaign.vue?vue&type=script&lang=js"
export * from "./Campaign.vue?vue&type=script&lang=js"

import "./Campaign.vue?vue&type=style&index=0&id=47c541e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c541e0"]])

export default __exports__